module.exports = __webpack_public_path__ + "img/delete_trash_can.fe213832.svg";